import { getNewId } from '../utils/Id';

/* UserActions is stored as:
	[
		{
			id: getNewId(),
			action: 'opened_card',
			params: {custom: 'object'},
			atDate: new Date(),
		},
	]
*/

export const getUserActions = () => JSON.parse(localStorage.getItem('userActions')) ?? [];

export const saveUserActions = (/** @type {any} */ newUserActions) =>
	localStorage.setItem('userActions', JSON.stringify(newUserActions));

export const addToUserActions = (/** @type {string} */ action, /** @type {{}} */ params) => {
	if (hasUserAction(action)) return;
	const userActions = getUserActions();
	userActions.push({
		id: getNewId(),
		action,
		params,
		atDate: new Date(),
	});
	saveUserActions(userActions);
};

export const hasUserAction = (/** @type {string} */ action) => {
	let foundUserAction = null;
	getUserActions().forEach((/** @type {{ action: any; }} */ item) => {
		if (item.action === action) foundUserAction = item;
	});
	return foundUserAction;
};
